import React from 'react';

const Footer = () => {
  return (
    <footer className="text-center text-gray-600 font-body font-semibold bg-gray-200 p-4">
      <span>Copyright Andre Ramadhan 2020</span>
    </footer>
  );
};

export default Footer;
